import { useAsync } from "react-async";
import { AxiosPendencyAPI } from "../Api";
import { Button, Grid, Icon, Loader, Popup, Table } from "semantic-ui-react";
import { ErrorSegment } from "../../common/components/ErrorSegment";
import React from "react";
import { PendencyEmployee } from "./PendencyEmployee";
import { NoRecords } from "../../common/components/NoRecords";
import { Icons } from "../../common/Icons";
import { useQueryWithPagination } from "../../utils/Hooks";
import { PaginationButtons } from "../../common/components/PaginationButtons";

export const PendencyCancelableList = () => {
  const { data, isPending, error, refetch, handleNext, handlePrevious } =
    useQueryWithPagination({
      queryKey: ["pendency-cancelable-list"],
      queryFn: AxiosPendencyAPI.getAll,
      cancelable: true,
    });

  if (isPending) return <Loader active />;
  if (error) return <ErrorSegment message={error.message} />;

  return (
    <>
      <PendencyCancelableTable data={data} reload={refetch} />
      <PaginationButtons
        previous={data?.previous}
        next={data?.next}
        onPrevious={handlePrevious}
        onNext={handleNext}
      />
    </>
  );
};

export const PendencyCancelableTable = ({ data, reload }) => {
  const { run: cancel } = useAsync({
    deferFn: async (args, props, controller) => {
      await AxiosPendencyAPI.cancel(args, props, controller);
      reload();
    },
  });

  if (!data) return;
  if (data.results.length === 0)
    return (
      <NoRecords
        iconName={Icons.ALL_DONE}
        message={"Não existem requisições abertas!"}
      />
    );

  let rows = data.results.map((pendency) => (
    <Table.Row key={pendency.id}>
      <Table.Cell>
        <PendencyEmployee employee={pendency.requester_employee} />
      </Table.Cell>
      <Table.Cell>
        <PendencyEmployee employee={pendency.target} />
      </Table.Cell>
      <Table.Cell>
        <PendencyEmployee employee={pendency.new_manager} />
      </Table.Cell>
      <Table.Cell>{pendency.change_date.format()}</Table.Cell>
      <Table.Cell>
        <Popup
          on={["click"]}
          position={"bottom center"}
          trigger={
            <Button animated basic>
              <Button.Content visible>
                <Icon name="trash" />
              </Button.Content>
              <Button.Content hidden>Cancelar</Button.Content>
            </Button>
          }
        >
          <Popup.Header>Deseja cancelar esta requisição?</Popup.Header>
          <Popup.Content>
            <Grid centered>
              <Grid.Row>
                <Button
                  onClick={() => cancel({ pendency_url: pendency.api_url })}
                >
                  Confirmar
                </Button>
              </Grid.Row>
            </Grid>
          </Popup.Content>
        </Popup>
      </Table.Cell>
    </Table.Row>
  ));

  return (
    <Table selectable padded="very">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Requerente</Table.HeaderCell>
          <Table.HeaderCell>Funcionário</Table.HeaderCell>
          <Table.HeaderCell>Novo gestor</Table.HeaderCell>
          <Table.HeaderCell>Data de mudança</Table.HeaderCell>
          <Table.HeaderCell>Ações</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>{rows}</Table.Body>
    </Table>
  );
};
